module.exports = __webpack_public_path__ + "img/1838.0f8cec9f.png";